<template>
  <HomePanel title="快速了解我们">
    <template v-slot:right>
      <ShMore to="/about" />
    </template>
    <div class="play">
      <video
        controls
        type="video/mp4"
        class="left"
        src="https://vod.3hvip.com/sv/15e17203-1947494cc4b/15e17203-1947494cc4b.mp4"
      ></video>
      <div class="right">
        <div class="rtop">
          <el-carousel
            :interval="4000"
            type="card"
            width="290px"
            height="165px"
          >
            <el-carousel-item>
              <img
                style="width: 290px"
                src="../../../../public/imgs/home-about-医学培训.png"
                alt=""
              />
            </el-carousel-item>
            <el-carousel-item>
              <img
                style="width: 290px"
                src="../../../../public/imgs/home-about-经典案例.png"
                alt=""
              />
            </el-carousel-item>
            <el-carousel-item>
              <img
                style="width: 290px"
                src="../../../../public/imgs/home-about-考前突击密训.png"
                alt=""
              />
            </el-carousel-item>
            <el-carousel-item>
              <img
                style="width: 290px"
                src="../../../../public/imgs/home-about-专属学习计划.png"
                alt=""
              />
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="rbottom">
          <div class="desc">
            <img src="../../../../public/icon/高阶培训.png" alt="" />
            <h3>高阶培训</h3>
            <p>线上、线下精品私教培训课程，小班化教学</p>
          </div>
          <div class="desc">
            <img src="../../../../public/icon/精研课程.png" alt="" />
            <h3>精研课程</h3>
            <p>北医名师授课培训，帮助掌握要点。</p>
          </div>
          <div class="desc">
            <img src="../../../../public/icon/AI题库.png" alt="" />
            <h3>Al智能题库</h3>
            <p>自主研发智能题库，数据整合智能出题、真实模拟考场</p>
          </div>
        </div>
      </div>
    </div>
  </HomePanel>
</template>

<script>
import HomePanel from "./home-panel";
import ShMore from "@/components/library/sh-more";

export default {
  components: {
    HomePanel,
    ShMore,
  },
  setup() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.play {
  display: flex;
  justify-content: space-between;
  padding-bottom: 8px;

  .left {
    width: 610px;
    height: 343px;
  }
  .right {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 580px;
    height: 343px;

    .rtop {
      width: 100%;
      height: 165px;
    }
    .rbottom {
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 165px;
      .desc {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 185px;
        height: 100%;
        background: #f0f0f0;
        border-radius: 5px;
        img {
          width: 80px;
          height: 80px;
        }
        p {
          margin: 5px 5px 0 5px;
        }
      }
    }
  }
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>
